import { SoftwareVersionOverridesRequest } from '../models/device.model';
import {
  LicenseBatchDto,
  LicenseBatchRequestDto,
} from '../models/license.model';

/**
 * The update request that leaves the batch as it is, apart from its software version overrides.
 * The update replaces the scope, validity period and auto-assignment, so all of them are carried
 * over from the batch.
 */
export function toLicenseBatchRequest(
  batch: LicenseBatchDto,
  softwareVersionOverrides: SoftwareVersionOverridesRequest,
): LicenseBatchRequestDto {
  return {
    name: batch.name,
    description: batch.description,
    companyId: batch.companyId ?? batch.company?.id,
    scope: batch.scope,
    licensedProductId: batch.licensedProductId ?? batch.product?.id,
    optionalValidBefore: batch.optionalValidBefore,
    optionalValidAfter: batch.optionalValidAfter,
    licenseBatchSize: batch.licenseBatchSize,
    autoAssignDeviceWithHardwareComponent:
      batch.autoAssignDeviceWithHardwareComponent,
    softwareVersionOverrides,
  };
}
